import "./style.css"

function LoadingAnimation() {
    return (
        <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
    );
}

export default LoadingAnimation;